import { Renderer } from './renderer';
import { Fillin } from '../model/fillin';
import { FillinList } from '../model/fillin-list';
import { SelectMultiple } from '../model/select-multiple';
import { Message } from './message';
import { MessageType } from '../types/render-types';


@Renderer.register("fillin")
@Renderer.register("fillin-list")
@Renderer.register("select-multiple")
export class FormRenderer extends Renderer {
    render(element: Fillin | FillinList | SelectMultiple, context: object): Message {
        let options: any = {};
        options['varName'] = element.varName;
        if (element instanceof SelectMultiple) {
            options['sourceVarName'] = element.sourceVarName;
            options['values'] = element.values;
        }

        return new Message(element.type as MessageType, options);
    }
}
